// react
import { Map } from "immutable";

// dependencies

// utils

const initialState = Map({
	activeModal: null,
});

export default function page(state = initialState, action) {
	switch (action.type) {
		case "MODALS:OPEN":
			return state.set("activeModal", action.modal);

		case "MODALS:CLOSE":
			return state.set("activeModal", null);

		default:
			return state;
	}
}
